export const copyRight = 'Copyright &copy homy.cc, All Rights Reserved.';
export const devCompany = '虹美影像科技';